import { render, staticRenderFns } from "./AssistantBubble.vue?vue&type=template&id=49790b7f&scoped=true&"
import script from "./AssistantBubble.vue?vue&type=script&lang=js&"
export * from "./AssistantBubble.vue?vue&type=script&lang=js&"
import style0 from "./AssistantBubble.vue?vue&type=style&index=0&id=49790b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49790b7f",
  null
  
)

/* nuxt-component-imports */
installComponents(component, {Header: require('/lasso/components/Header.vue').default,AssistantChat: require('/lasso/components/AssistantChat.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49790b7f')) {
      api.createRecord('49790b7f', component.options)
    } else {
      api.reload('49790b7f', component.options)
    }
    module.hot.accept("./AssistantBubble.vue?vue&type=template&id=49790b7f&scoped=true&", function () {
      api.rerender('49790b7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AssistantBubble.vue"
export default component.exports